import React, { useEffect, useState, useRef } from "react";
import "./index.less";
import Logo from "@/assets/images/zdlogo.svg";
import SetImg from "@/assets/images/set.svg";
import WelcomeLogo from "@/assets/images/welcomeLogo.png";
import Ykzs from "@/assets/images/ykzs.png";
import Zwxz from "@/assets/images/zwxz.png";
import Zxb from "@/assets/images/zxb.png";
import Yxy from "@/assets/images/yxy.png";
import Lx from "@/assets/images/lx.png";
import Xzzd from "@/assets/images/xzzd.png";
import Etlink from "@/assets/images/etlink.png";
import FxwxSmall from "@/assets/images/fxwxsmall.png";
import PlayIcon from "@/assets/images/play.svg";
import DisPlayIcon from "@/assets/images/display.svg";
import {
  ChatBox,
  ChatThinkActionButton,
  ChatScrollWrapper,
  ChatActionButton,
  ChatBoxItem,
  ChatBubblePromptsCard,
} from "@sui/chat-ui";
import {
  Select,
  Button,
  Row,
  Col,
  Typography,
  Tooltip,
  Modal,
  Drawer,
  Space,
} from "antd";
import {
  CloseOutlined,
  CloudUploadOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { API, getSkillList } from "@/api";
import { getChatUrl, isMobile } from "@/utils/public";
import useBaseRequest from "@/hooks/useBaseRequest";
import { useArraySlicer } from "@/hooks/zdindex";
import Fj from "@/assets/images/fj.svg";
import { Attachments } from "@ant-design/x";
import ZdKnowledge from "../../../pages/chat/zsk";

function ZdHome() {
  const [newData, setNewData] = useState([]);
  const [newInit, setNewInit] = useState(false);
  const [initObj, setInitObj] = useState({});
  const [newZntData, setNewZntData] = useState([]);
  const [deepthink, setDeepthink] = useState(true);
  const [skillList, setSkillList] = useState([]);
  const [hotList, setHotList] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [recording, setRecording] = useState(false);
  const [skillsName, setSkillName] = useState("");
  const [newInputId, setNewInputId] = useState("");
  const [zdzxJump, setZdzxJump] = useState(false);
  const [newSoltInput, setNewSoltInput] = useState(undefined);
  const [newRefresh, setNewRefresh] = useState("");
  const [zdKnowledgeOpen, setZdKnowledgeOpen] = useState(false);
  const [zdKnowledgeName, setZdKnowledgeName] = useState("");
  const [selectedValue, setSelectedValue] = useState({});
  const [chooseZskType, setChooseZskType] = useState("");
  const zdKnowledgeRef = useRef();
  const audioRef = useRef();

  const hotListRef = useRef();

  useEffect(() => {
    axios.all([getInitData(), getZntDatas(), getHots()]).then(
      axios.spread((res, res1, res2) => {
        console.log("宁波理工===", res1);
        const data = res?.data?.result?.data;
        const data1 = res1?.data?.result?.data || [];
        const data2 = res2?.data || [];
        const arr = [];
        const arr1 = [];
        const arr2 = [];
        data.hotqas?.map((item) => {
          arr.push({
            key: item.id,
            description: item.name,
          });
        });
        data2.map((item, index) => {
          arr2.push({
            id: item.sys_id,
            description: index + 1 + "、" + item.sys_title,
            url: item.sys_link,
          });
        });

        data1.map((item) => {
          if (item.id * 1 === 4 || item.id * 1 === 5) {
            arr1.push({
              name: item.name,
              description: item.summary,
              icon: item.icon,
              id: item.id,
            });
          }
        });
        setNewInit(true);
        setNewData(arr);
        setInitObj(data);
        setNewZntData(arr1);
        setHotList(arr2.slice(0, 8));
        hotListRef.current = arr2;
        runGetAllSkill(data?.id);
        setA(Math.random());
        setNewRefresh(Math.random());
      }),
    );
  }, []);

  const getInitData = () => {
    return axios.get(API.serInit);
  };

  const getZntDatas = () => {
    return axios.get(API.categaryList);
  };

  const getHots = () => {
    return axios.get(
      "https://service.zju.edu.cn/_web/customized/queryHotArticles.jsp?_p=YXM9MSZwPTEmbT1OJg__",
    );
  };

  //获取所有的任务列表
  const {
    data: getAllSkillData,
    loading: getAllSkillLoading,
    runAsync: runGetAllSkill,
  } = useBaseRequest((params) => getSkillList(params), {
    manual: true,
    onSuccess: (res) => {
      setSkillList(res?.data);
    },
  });

  const promptsItems = hotList?.length
    ? hotList.map((subject) => {
        return {
          key: subject.id,
          description: subject.description,
          url: subject.url,
        };
      })
    : undefined;

  const nextHots = useArraySlicer(hotListRef.current, 8);
  const onReloadHots = () => {
    setHotList(nextHots());
  };

  useEffect(() => {
    if (initObj?.userId && initObj?.forcelogin === 0) {
      // window.location.href = initObj?.loginUrl;
      window.open("./#/zdChat", "_self");
    } else {
    }
  }, [initObj?.id]);

  const loginFun = (val) => {
    if (!initObj?.userId && initObj?.forcelogin === 1) {
      if (process.env.NODE_ENV === "development") {
        return;
      }
      window.location.href = initObj?.loginUrl;
    } else {
      console.log(newSoltInput);
      if (zdzxJump) {
        window.open(`http://10.204.19.136/#?searchType=zh&keyword=${val}`);
      } else {
        if (fileList && fileList.length) {
          window.sessionStorage.setItem("files", JSON.stringify(fileList));
        }
        window.sessionStorage.setItem(
          "question",
          JSON.stringify(encodeURIComponent(val)),
        );
        if (newInputId) {
          window.sessionStorage.setItem("skillId", JSON.stringify(newInputId));
        }
        if (skillsName) {
          window.sessionStorage.setItem(
            "skillName",
            JSON.stringify(skillsName),
          );
        }
        if (newSoltInput) {
          window.sessionStorage.setItem("forms", JSON.stringify(newSoltInput));
        }
        if (selectedValue) {
          window.sessionStorage.setItem(
            "selectedValue",
            JSON.stringify(selectedValue),
          );
        }
        window.sessionStorage.setItem(
          "newInputSubmit",
          JSON.stringify(newInputId ? true : false),
        );
        window.open(`./#/zdChat`, "_self");
      }
    }
  };

  //语音播放
  // 播放/暂停
  const togglePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        console.log("停止");
        audioRef.current.pause();
      } else {
        console.log("播放");
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  // 基础状态
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  // 新增：控制hover状态
  const [isListHover, setIsListHover] = useState(false);
  const [isBott, setIsAtBottom] = useState(false);
  const [fixedHeight, setFixedHeight] = useState(false);
  const [a, setA] = useState("");
  const [chooseZsk, setChooseZsk] = useState(false);
  // 新增：底部状态锁定，避免反复刷新

  // Ref定义
  const scrollContainerRef = useRef(null);

  const checkScreenSize = () => {
    setIsSmallScreen(window.innerHeight < 975);
  };

  // 监听屏幕尺寸变化
  useEffect(() => {
    // 初始检查
    checkScreenSize();

    // 监听resize事件
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, [a]);

  const [bigScreen, setIsBigScreen] = useState(false);

  const checkScreenSizeBig = () => {
    setIsBigScreen(window.innerHeight >= 975);
  };

  useEffect(() => {
    checkScreenSizeBig();
    // 监听resize事件
    window.addEventListener("resize", checkScreenSizeBig);

    return () => {
      window.removeEventListener("resize", checkScreenSizeBig);
    };
  }, [a]);

  const handleScroll2 = () => {
    const senderHeight = document
      .getElementsByClassName("sui-chatui-box-senderbox")[0]
      ?.getBoundingClientRect();
    if (!bigScreen || !scrollContainerRef.current) return;
    console.log(senderHeight, scrollContainerRef.current, "这个高度是多少");
    if (senderHeight.top < 120) {
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.position = "fixed";
      document.getElementsByClassName("sui-chatui-box-senderbox")[0].style.top =
        "80px";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.width = "100%";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.zIndex = "111";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.paddingRight = "11px";
    }

    if (scrollContainerRef.current.scrollTop === 0) {
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.position = "unset";
      document.getElementsByClassName("sui-chatui-box-senderbox")[0].style.top =
        "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.width = "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.zIndex = "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.paddingRight = "unset";
    }
  };

  useEffect(() => {
    if (!scrollContainerRef.current) return;
    const container = scrollContainerRef.current;

    container.addEventListener("scroll", handleScroll2);
    return () => container.removeEventListener("scroll", handleScroll2);
  }, [bigScreen, a]);

  const handleScroll = () => {
    setScrollTop(scrollContainerRef?.current.scrollTop);

    // 判断是否滚动到底部
    const isAtBottom =
      scrollContainerRef?.current.scrollHeight -
        scrollContainerRef?.current.scrollTop <=
      scrollContainerRef?.current.clientHeight + 1;
    const threshold = 10;

    const isNearBottom =
      scrollContainerRef?.current.scrollHeight -
        scrollContainerRef?.current.scrollTop <=
      scrollContainerRef?.current.clientHeight + threshold;
    const scollHeight = document
      .getElementsByClassName("cards")[0]
      .getBoundingClientRect();

    const senderHeight = document
      .getElementsByClassName("sui-chatui-box-senderbox")[0]
      ?.getBoundingClientRect();
    console.log(senderHeight, "这是多少");
    if (window.innerHeight - scollHeight.top > 350) {
      // setIsAtBottom(true);
      setFixedHeight(true);
    } else {
      // setFixedHeight(false);
      // setIsAtBottom(false);
    }

    if (senderHeight.top < 120) {
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.position = "fixed";
      document.getElementsByClassName("sui-chatui-box-senderbox")[0].style.top =
        "80px";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.width = "100%";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.zIndex = "111";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.paddingRight = "11px";
    }

    if (scrollContainerRef.current.scrollTop === 0) {
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.position = "unset";
      document.getElementsByClassName("sui-chatui-box-senderbox")[0].style.top =
        "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.width = "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.zIndex = "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.paddingRight = "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.transform = "transform 0.3s ease";
    }

    // if (isNearBottom) {
    //   // console.log("已滚动到底部");
    //   setIsAtBottom(true);
    //   // container.removeEventListener("scroll", handleScroll)
    // } else {
    //   setIsAtBottom(false);
    // }
  };
  // 2. 监听滚动容器滚动
  useEffect(() => {
    if (!isSmallScreen || !scrollContainerRef.current) return;
    const container = scrollContainerRef.current;

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [isSmallScreen, a]);

  // 3. 计算旋转角度（hover时强制为0）
  const getRotateAngle = () => {
    // hover状态下直接回正，否则按滚动计算
    if (isListHover || !isSmallScreen) return 0;

    const container = scrollContainerRef.current;
    if (!container) return 0;

    const maxScroll = container.scrollHeight - container.clientHeight;

    const angle = 30 - (scrollTop / (maxScroll || 1)) * 30;
    return Math.max(angle, 0);
  };

  // 4. hover事件处理（绑定到list外层）
  const handleListMouseEnter = () => {
    setIsListHover(true);
  };

  const handleListMouseLeave = () => {
    setIsListHover(false);
  };

  //上传图片相关
  const [fileOpen, setFileOpen] = useState(false);
  const attachmentsRef = useRef(null);
  const [fileList, setFileList] = useState([]);
  const picRef = useRef();
  const fileRef = useRef();
  const fileAndImgRef = useRef();

  //文件和图片上传相关
  const header = fileOpen ? (
    <div
      style={{
        minHeight: "120px",
        background: "#fff",
        borderRadius: "12px",
        position: "relative",
      }}
      className="headerFile"
    >
      <div
        style={{
          textAlign: "right",
          position: "absolute",
          right: "10px",
          top: "10px",
          zIndex: "99",
        }}
      >
        <CloseOutlined
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            setFileOpen(false);
            setFileList([]);
          }}
        />
      </div>
      <Attachments
        overflow="scrollX"
        ref={attachmentsRef}
        items={fileList}
        multiple={true}
        accept={
          initObj?.enabledfileupload * 1 === 1 &&
          initObj?.enabledimgupload * 1 === 1
            ? ".jpg,.jpeg,.png,.csv,.md,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
            : initObj?.enabledimgupload * 1 === 1
            ? ".jpg,.jpeg,.png,"
            : initObj?.enabledfileupload * 1 === 1
            ? ".csv,.md,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
            : ""
        }
        maxCount={
          initObj?.enabledfileupload * 1 === 1 &&
          initObj?.enabledimgupload * 1 === 1
            ? initObj?.fileuploadcount * 1 + initObj?.imguploadcount * 1
            : initObj?.enabledfileupload * 1 === 1
            ? initObj?.fileuploadcount * 1
            : initObj?.enabledimgupload * 1 === 1
            ? initObj?.imguploadcount * 1
            : undefined
        }
        beforeUpload={(file) => {
          let uploadTypes = [];
          if (
            initObj?.enabledfileupload * 1 === 1 &&
            initObj?.enabledimgupload * 1 === 1
          ) {
            uploadTypes = [
              "image/jpeg",
              "image/png",
              "image/gif",
              "image/bmp",
              "application/pdf",
              "application/msword", // .doc
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
              "application/vnd.ms-powerpoint", // .ppt
              "application/vnd.ms-excel", // .xls
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
              "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
              "text/markdown", // .md
              "text/csv", // .csv
              "text/plain", // 兼容扩展名检查
            ];
          } else {
            if (initObj?.enabledfileupload * 1 === 1) {
              uploadTypes = uploadTypes = [
                "application/pdf",
                "application/msword", // .doc
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
                "application/vnd.ms-powerpoint", // .ppt
                "application/vnd.ms-excel", // .xls
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
                "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
                "text/markdown", // .md
                "text/csv", // .csv
                "text/plain", // 兼容扩展名检查
              ];
            }

            if (initObj?.enabledimgupload * 1 === 1) {
              uploadTypes = [
                "image/jpeg",
                "image/png",
                "image/gif",
                "image/bmp",
              ];
            }
          }

          const newCount = fileList.length + 1; // 当前已选 + 待上传
          if (
            initObj?.enabledfileupload * 1 === 1 &&
            initObj?.enabledimgupload * 1 === 1
          ) {
            const imageCount = fileList.filter(
              (file) => file.type === "image",
            ).length;
            const fileCount = fileList.filter(
              (file) => file.type === "document",
            ).length;
            if (imageCount >= initObj?.imguploadcount * 1) {
              message.warning(
                `最多只能上传${initObj?.imguploadcount * 1}张图片`,
              );
              return false;
            }

            if (fileCount >= initObj?.fileuploadcount * 1) {
              message.warning(
                `最多只能上传${initObj?.fileuploadcount * 1}个附件`,
              );
              return false;
            }

            if (
              newCount >
              initObj?.fileuploadcount * 1 + initObj?.imguploadcount * 1
            ) {
              message.warning(
                `最多只能上传${
                  initObj?.fileuploadcount * 1 + initObj?.imguploadcount * 1
                }个附件`,
              );
              return false;
            }
          } else {
            if (initObj?.enabledfileupload * 1 === 1) {
              if (newCount > initObj?.fileuploadcount * 1) {
                message.warning(
                  `最多只能上传${initObj?.fileuploadcount * 1}个附件`,
                );
                return false;
              }
            }

            if (initObj?.enabledimgupload * 1 === 1) {
              if (newCount > initObj?.imguploadcount * 1) {
                message.warning(
                  `最多只能上传${initObj?.imguploadcount * 1}张图片`,
                );
                return false;
              }
            }
          }

          const isAllowed =
            uploadTypes.includes(file.type) ||
            file.name.includes("md") ||
            file.name.includes("MD");

          // 获取文件扩展名
          const fileName = file.name;
          const extension = fileName
            .substring(fileName.lastIndexOf(".") + 1)
            .toLowerCase();

          // 设置不同文件类型的大小限制
          const isImage = ["jpg", "jpeg", "png"].includes(extension);
          const maxSize = isImage ? 30 * 1024 * 1024 : 100 * 1024 * 1024; // 图片30MB，其他文件100MB

          if (file.size > maxSize) {
            message.error(
              `${isImage ? "图片" : "文件"}大小不能超过${
                isImage ? "30MB" : "100MB"
              }`,
            );
            return Upload.LIST_IGNORE;
          }

          if (!isAllowed) {
            message.error(
              "仅支持图片、文档、Markdown (.md) 和 CSV (.csv) 文件",
            );
            return Upload.LIST_IGNORE; // 阻止添加到文件列表
          }

          return true;
        }}
        onRemove={(file) => {
          const newFileList = fileList.filter((item) => item.uid !== file.uid);
          setFileList(fileList && fileList.length ? newFileList : []);
        }}
        customRequest={(val) => {
          const { file } = val;
          const formData = new FormData();
          formData.append("files", file);
          axios
            .post(API.uploadDocs, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              const data = res?.data?.result?.data || [];
              const arr = [];
              data.map((item) => {
                arr.push({
                  uid: item.uuid,
                  name: item.filename,
                  status: "done",
                  url:
                    API.askDownLoadDocs +
                    `/${item.uuid}.${item?.filename?.split(".")[1]}`,
                  type: item.type,
                  uuid: item.uuid,
                  size: file.size,
                });
              });
              setFileList([...fileList, ...arr]);
            });
        }}
        placeholder={(type) =>
          type === "drop"
            ? {
                title: "Drop file here",
              }
            : {
                icon: <CloudUploadOutlined />,
                title: "上传文件",
                description: "单击或拖动文件到此区域进行上传",
              }
        }
      ></Attachments>
    </div>
  ) : undefined;

  return newInit ? (
    <div className="zdHome">
      <div className="content">
        <div className="header">
          <div className="logo">
            <img src={Logo} alt=" " />
          </div>
          <div className="loginInfo">
            <div
              className="setImg"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                if (!initObj?.userId && initObj?.forcelogin === 1) {
                  if (process.env.NODE_ENV === "development") {
                    return;
                  }
                  window.location.href = initObj?.loginUrl;
                } else {
                  window.open(`./#/zdChat`, "_self");
                }
              }}
            >
              体验更多
              {/* <img src={SetImg} alt=" " /> */}
            </div>
            <div className="line">
              <div
                style={{
                  width: "1px",
                  height: "16px",
                  background: "#fff",
                }}
              ></div>
            </div>
            <div
              className="login"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                if (!initObj?.userId && initObj?.forcelogin === 1) {
                  if (process.env.NODE_ENV === "development") {
                    return;
                  }
                  window.location.href = initObj?.loginUrl;
                } else {
                  Modal.confirm({
                    title: "",
                    content: "是否需要退出登录？",
                    okText: "确定",
                    cancelText: "取消",
                    onOk() {
                      window.location.href = window.logoutUrl;
                    },
                  });
                }
                // loginFun();
              }}
            >
              {initObj?.userName ?? initObj?.userId ?? "登录"}
            </div>
          </div>
        </div>
        <div className="wrapContent" ref={scrollContainerRef}>
          <ChatBox
            key={"key" + newRefresh}
            className="zdHomeContent"
            placeholder="给 AI 发送消息（按 Enter 提交，Shift + Enter 换行）"
            welcome={{
              title: "",
              description: (
                <span
                  style={{
                    color: "#fff",
                    fontSize: "26px",
                    fontWeight: "bold",
                  }}
                >
                  浙大人的AI服务平台
                </span>
              ),
              icon: WelcomeLogo,
            }}
            header={header}
            slotsInput={newSoltInput}
            actions={[
              window.showThinking ? (
                initObj?.thinking === false || skillsName ? (
                  <>
                    {chooseZsk ? (
                      <ChatThinkActionButton
                        noTitle={false}
                        key={"deepthink"}
                        checkable
                        value={deepthink}
                        onChange={setDeepthink}
                      >
                        {isMobile() ? "" : "深度思考"}
                      </ChatThinkActionButton>
                    ) : null}
                  </>
                ) : (
                  <>
                    <ChatThinkActionButton
                      noTitle={false}
                      key={"deepthink"}
                      checkable
                      value={deepthink}
                      onChange={setDeepthink}
                      onClick={() => {
                        loginFun();
                      }}
                    >
                      {isMobile() ? "" : "深度思考"}
                    </ChatThinkActionButton>
                    {window.zdZsk ? (
                      zdKnowledgeName ? (
                        <>
                          <ChatActionButton>
                            <span>{zdKnowledgeName}</span>
                            <CloseOutlined
                              onClick={() => {
                                setZdKnowledgeName("");
                              }}
                            />
                          </ChatActionButton>
                        </>
                      ) : (
                        <ChatActionButton
                          onClick={() => {
                            setZdKnowledgeOpen(true);
                          }}
                        >
                          {"请选择知识库"}
                        </ChatActionButton>
                      )
                    ) : null}
                  </>
                )
              ) : null,
            ]}
            beforeSendActions={
              <>
                {initObj?.enabledimgupload * 1 === 1 &&
                initObj?.enabledfileupload * 1 === 1 ? (
                  <>
                    <Tooltip
                      title={
                        <div>
                          {`请上传图片或者文件（最多上传${initObj?.imguploadcount}张图片，每张图片大小30M以内，支持JPG, JPEG, PNG格式，最多上传${initObj?.fileuploadcount}个文件，每个文件大小100MB以内，支持TXT、PDF、 XLSX、 XLS、 DOCX、 CSV、 MD格式）`}
                        </div>
                      }
                    >
                      <span
                        onClick={() => {
                          fileAndImgRef?.current?.click();
                        }}
                      >
                        <img
                          style={{
                            width: "24px",
                            height: "24px",
                            cursor: "pointer",
                          }}
                          src={window.zdDisabledFj ? DisFj : Fj}
                          alt=" "
                        />
                        {window.zdDisabledFj ? (
                          ""
                        ) : (
                          <input
                            type="file"
                            style={{
                              display: "none",
                            }}
                            ref={fileAndImgRef}
                            onClick={() => {
                              setTimeout(() => {
                                setFileOpen(true);
                              }, 3);
                            }}
                            onChange={(a) => {
                              if (window.zdDisabledFj) {
                              } else {
                                setTimeout(() => {
                                  if (
                                    a.target.files &&
                                    a.target.files.length > 0 &&
                                    attachmentsRef.current?.upload
                                  ) {
                                    for (const file of a.target.files) {
                                      try {
                                        attachmentsRef.current.upload(file); // 异步处理
                                      } catch (error) {
                                        console.error(
                                          "Error uploading file:",
                                          error,
                                        );
                                      }
                                    }
                                  } else {
                                  }
                                }, 5);
                              }
                            }}
                          />
                        )}
                      </span>
                    </Tooltip>
                  </>
                ) : (
                  <>
                    {initObj?.enabledimgupload * 1 === 1 ? (
                      <Tooltip
                        title={`${
                          initObj?.enabledimgupload * 1 === 1 &&
                          initObj?.enabledfileupload * 1 === 1
                            ? "请上传图片或者文件"
                            : initObj?.enabledimgupload * 1 === 1
                            ? `请上传图片（最多上传${initObj?.imguploadcount}张图片，每张图片大小30M以内，支持JPG, JPEG, PNG格式`
                            : ""
                        }`}
                      >
                        {" "}
                        <span
                          onClick={() => {
                            picRef?.current?.click();
                          }}
                        >
                          <img
                            style={{
                              width: "24px",
                              height: "24px",
                              cursor: "pointer",
                            }}
                            src={Fj}
                            alt=" "
                          />
                          <input
                            type="file"
                            style={{
                              display: "none",
                            }}
                            ref={picRef}
                            onChange={(a) => {
                              setFileOpen(true);
                              setTimeout(() => {
                                if (
                                  a.target.files &&
                                  a.target.files.length > 0 &&
                                  attachmentsRef.current?.upload
                                ) {
                                  for (const file of a.target.files) {
                                    try {
                                      attachmentsRef.current.upload(file); // 异步处理
                                    } catch (error) {
                                      console.error(
                                        "Error uploading file:",
                                        error,
                                      );
                                    }
                                  }
                                }
                              }, 5);
                            }}
                          />
                        </span>{" "}
                      </Tooltip>
                    ) : undefined}

                    {initObj?.enabledfileupload * 1 === 1 ? (
                      <Tooltip
                        title={
                          <div>{`${
                            initObj?.enabledimgupload * 1 === 1 &&
                            initObj?.enabledfileupload * 1 === 1
                              ? "请上传图片或者文件"
                              : initObj?.enabledfileupload * 1 === 1
                              ? `请上传文件，最多上传${initObj?.fileuploadcount}个文件，每个文件大小100MB以内，支持TXT、PDF、XLSX、XLS、DOCX、CSV、MD格式`
                              : ""
                          }`}</div>
                        }
                      >
                        <span
                          onClick={() => {
                            fileRef?.current?.click();
                          }}
                        >
                          <img
                            style={{
                              width: "24px",
                              height: "24px",
                              cursor: "pointer",
                            }}
                            src={Fj}
                            alt=" "
                          />
                          <input
                            type="file"
                            style={{
                              display: "none",
                            }}
                            ref={fileRef}
                            onChange={(a) => {
                              setFileOpen(true);
                              setTimeout(() => {
                                if (
                                  a.target.files &&
                                  a.target.files.length > 0 &&
                                  attachmentsRef.current?.upload
                                ) {
                                  for (const file of a.target.files) {
                                    try {
                                      attachmentsRef.current.upload(file); // 异步处理
                                    } catch (error) {
                                      console.error(
                                        "Error uploading file:",
                                        error,
                                      );
                                    }
                                  }
                                }
                              }, 5);
                            }}
                          />
                        </span>
                      </Tooltip>
                    ) : undefined}
                  </>
                )}
              </>
            }
            minRows={3}
            onSubmit={(val) => {
              loginFun(val);
            }}
            prefix={
              skillsName ? (
                <>
                  <Button
                    icon={
                      <CloseOutlined
                        onClick={() => {
                          setSkillName("");
                          setChooseZsk(false);
                          setNewSoltInput(undefined);
                          setNewRefresh(Math.random());
                          setNewInputId("");
                        }}
                        style={{
                          fontSize: "12px",
                          color: "",
                        }}
                      />
                    }
                    iconPosition="end"
                    type="text"
                    style={{
                      color: "#1677ff",
                      background: "#0066ff0f",
                    }}
                    size="large"
                  >
                    {skillsName}
                  </Button>
                </>
              ) : (
                ""
              )
            }
            renderAfterSenderBox={() => {
              const skillsItems =
                window.zdSkills && window.zdSkills.length
                  ? [...window.zdSkills, ...skillList]
                  : skillList || [];
              return (
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <div
                    className="jn"
                    style={{
                      padding: "20px 0",
                      width: "100%",
                    }}
                  >
                    <ChatBoxItem>
                      <ChatScrollWrapper key={"len" + skillsItems.length}>
                        {skillsItems.map((item) => {
                          return (
                            <ChatActionButton
                              style={{
                                padding: "20px 30px",
                              }}
                              key={item.id}
                              onClick={() => {
                                if (
                                  !initObj?.userId &&
                                  initObj?.forcelogin === 1
                                ) {
                                  if (process.env.NODE_ENV === "development") {
                                    return;
                                  }
                                  window.location.href = initObj?.loginUrl;
                                } else {
                                  if (item.type === "zsk") {
                                    setZdKnowledgeOpen(true);
                                    setChooseZsk(true);
                                  } else {
                                    setChooseZsk(false);
                                    setZdKnowledgeOpen(false);
                                    setSelectedValue({ key: "" });
                                  }
                                  if (item.slots && item.slots.length) {
                                    let obj = {
                                      slots: [],
                                    };
                                    if (item.id.includes("mcp")) {
                                      item.slots?.map((param) => {
                                        obj.slots.push({
                                          name: param?.field,
                                          label: param?.fieldName,
                                          required: param?.required,
                                          defaultValue: param?.defaultValue,
                                          // placeholder: param?.example,
                                          placeholder: "",
                                          type: param?.enumValues
                                            ? "select"
                                            : param?.type,
                                          options: (
                                            param?.enumValues || []
                                          ).map((jtem) => {
                                            return {
                                              label: jtem,
                                              value: jtem,
                                            };
                                          }),
                                          query: param?.query,
                                        });
                                      });
                                    }
                                    if (item.id === "mcp_17_translate") {
                                      // item.slots?.map((param) => {
                                      //   obj.slots.push({
                                      //     name: param?.field,
                                      //     label: param?.fieldName,
                                      //     required: param?.required,
                                      //     defaultValue: param?.value,
                                      //     placeholder: param?.example,
                                      //     type:
                                      //       param.field === "target_language"
                                      //         ? "select"
                                      //         : param?.type === "string"
                                      //         ? "input"
                                      //         : param?.type,
                                      //     options: (
                                      //       param?.enumValues || []
                                      //     ).map((jtem) => {
                                      //       return {
                                      //         label: jtem,
                                      //         value: jtem,
                                      //       };
                                      //     }),
                                      //     query: param?.query,
                                      //   });
                                      // });
                                    } else if (item.id === "mcp_17_ocr") {
                                      obj.slots.push({});
                                    } else {
                                      // item.slots?.map((param) => {
                                      //   obj.slots.push({
                                      //     name: param?.field,
                                      //     label: param?.fieldName,
                                      //     required: param?.required,
                                      //     defaultValue: param?.value,
                                      //     placeholder: param?.example,
                                      //     type:
                                      //       param?.type === "string"
                                      //         ? "input"
                                      //         : param?.type,
                                      //     options: param?.options,
                                      //     query: param?.query,
                                      //   });
                                      // });
                                    }

                                    if (item.id === "mcp_17_ocr") {
                                      setNewSoltInput(undefined);
                                    } else {
                                      setNewSoltInput({ ...obj });
                                    }
                                    setNewRefresh(Math.random());
                                  } else {
                                    setNewSoltInput(undefined);
                                    setNewRefresh(Math.random());
                                  }
                                  if (item.type === "zdzx") {
                                    setZdzxJump(true);
                                  } else {
                                    setZdzxJump(false);
                                  }
                                  if (item.type !== "zsk") {
                                    setNewInputId(item.id);
                                  }
                                  setSkillName(item.name);
                                }
                              }}
                            >
                              {item.name}
                            </ChatActionButton>
                          );
                        })}
                      </ChatScrollWrapper>
                    </ChatBoxItem>
                  </div>
                  <div className="jx">
                    <ChatBoxItem>
                      <ChatBubblePromptsCard
                        size="small"
                        title={
                          <>
                            <span
                              style={{
                                fontSize: "22px",
                                color: "#AD0000",
                                fontStyle: "italic",
                              }}
                            >
                              热点
                            </span>
                            <span
                              style={{
                                display: "inline-block",
                                width: "3px",
                                height: "3px",
                                borderRadius: "3px",
                                background: "#333",
                              }}
                            ></span>
                            <span
                              style={{
                                fontSize: "22px",
                                color: "#333",
                                fontStyle: "italic",
                              }}
                            >
                              资讯
                            </span>
                            <span
                              className="aibb"
                              onClick={() => {
                                console.log(audioRef);
                                togglePlayPause();
                                // axios.get(
                                //   "https://service.zju.edu.cn/_upload/aijb/aijb.mp3"
                                // );
                              }}
                            >
                              <img
                                style={{
                                  width: "23px",
                                }}
                                src={isPlaying ? DisPlayIcon : PlayIcon}
                              />
                              <span
                                style={{
                                  paddingLeft: "10px",
                                }}
                              >
                                AI播报
                              </span>
                              <audio
                                ref={audioRef}
                                src={window.audioLink || ""}
                              />
                            </span>
                          </>
                        }
                        column={2}
                        //@ts-ignore
                        shape="round"
                        arrowType="swapright"
                        type="primary"
                        extra={
                          <>
                            {hotListRef.current?.length > 8 ? (
                              <Button
                                onClick={onReloadHots}
                                style={{ color: "inherit" }}
                                type="text"
                                icon={<ReloadOutlined />}
                              >
                                换一换
                              </Button>
                            ) : null}
                          </>
                        }
                        onItemClick={(info) => {
                          console.log(info);
                          window.open(info.data?.url);
                          // StartChat(info.data.title?.toString())
                        }}
                        items={promptsItems?.slice(0, 8)}
                      />
                    </ChatBoxItem>
                  </div>
                  <div
                    style={{
                      padding: "10px 0",
                      height: "700px",
                    }}
                    className="cards"
                  >
                    <ChatBoxItem>
                      <div className="scrollWrapper">
                        {/* 外层list绑定hover事件 */}
                        <div
                          className="list"
                          // onMouseEnter={handleListMouseEnter}
                          // onMouseLeave={handleListMouseLeave}
                        >
                          {/* divder：hover时padding消失 */}
                          <div
                            className="divder"
                            style={{
                              // hover优先：hover时unset，否则按小屏逻辑
                              // paddingTop:
                              //   isListHover || isBott
                              //     ? "unset"
                              //     : isSmallScreen || fixedHeight
                              //     ? "87px"
                              //     : "unset",
                              paddingTop:
                                fixedHeight || bigScreen ? "unset" : "87px",
                            }}
                          ></div>

                          {/* listContent：hover时flexWrap改为wrap */}
                          <div
                            className="listContent"
                            style={{
                              color: "#fff",
                              display: "flex",
                              flexDirection: "row",
                              // hover优先：hover时wrap，否则按小屏逻辑
                              // flexWrap:
                              //   isListHover || isBott
                              //     ? "wrap"
                              //     : isSmallScreen
                              //     ? "nowrap"
                              //     : "wrap",
                              // flexWrap:
                              //   !isSmallScreen || isListHover || isBott
                              //     ? "wrap"
                              //     : "nowrap",
                              flexWrap:
                                fixedHeight || bigScreen ? "wrap" : "nowrap",
                              // !isSmallScreen || !fixedHeight
                              //   ? "wrap"
                              //   : "nowrap",
                              transform: "transform 0.3s ease",
                            }}
                          >
                            {/* 所有listItem：hover时回正，否则按滚动/小屏逻辑 */}
                            <div
                              className="listItem"
                              style={{
                                transform: `rotate(${
                                  fixedHeight ? 0 : getRotateAngle()
                                }deg)`,
                                transition: "transform 0.3s ease",
                              }}
                            >
                              <div className="listItemContent">
                                {/* <div className="name">
                                  <span>教学</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self"
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="imgs">
                                  <Row gutter={[16, 16]}>
                                    <Col span={8}>
                                      <div
                                        className="list_item jximg1"
                                        onClick={() => {
                                          window.open(
                                            "https://classroom.zju.edu.cn/ "
                                          );
                                        }}
                                      >
                                        <span className="title">智云课堂</span>
                                      </div>
                                    </Col>
                                    <Col span={8}>
                                      <div
                                        className="list_item jximg2"
                                        onClick={() => {
                                          window.open(
                                            "https://course.zju.edu.cn/ "
                                          );
                                        }}
                                      >
                                        <span className="title">学在浙大</span>
                                      </div>
                                    </Col>
                                    <Col span={8}>
                                      <div
                                        className="list_item jximg3"
                                        onClick={() => {
                                          window.open(
                                            "https://365.kdocs.cn/3rd/lingxi/read"
                                          );
                                        }}
                                      >
                                        <span className="title">AI阅读</span>
                                      </div>
                                    </Col>
                                  </Row>
                                </div> */}
                                <div className="name">
                                  <span>教育教学</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self",
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="yygc">
                                  <Row>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://course.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem  xzzd"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"学在浙大"}>
                                                学在浙大
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                贯穿课前、课中、课后的全过程沉浸式交互教学管理平台
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://classroom.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem zykt"> </div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"智云课堂"}>
                                                智云课堂
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                线上线下混合式同步课堂
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://ai-assistant-h5.zju.edu.cn/portal/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem aizj"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"课程AI助教"}>
                                                课程AI助教
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                浙江大学本科课程AI助教平台
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://elang.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem hxwy"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"慧学外语"}>
                                                慧学外语
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                GenAI驱动、对标CSE量表并结合认知诊断的个性化英语自主学习平台
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                            <div
                              className="listItem"
                              style={{
                                transform: `rotate(${
                                  fixedHeight ? 0 : getRotateAngle()
                                }deg)`,
                                transition: "transform 0.3s ease",
                              }}
                            >
                              <div className="listItemContent">
                                {/* <div className="name">
                                  <span>科研</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self"
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="imgs">
                                  <Row gutter={[16, 16]}>
                                    <Col span={12}>
                                      <div
                                        className="list_item jximg4"
                                        onClick={() => {
                                          window.open(
                                            "https://365.kdocs.cn/3rd/lingxi/creative"
                                          );
                                        }}
                                      >
                                        <span className="title">AI创作</span>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        className="list_item jximg5"
                                        onClick={() => {
                                          window.open(
                                            "https://365.kdocs.cn/3rd/lingxi/ppt "
                                          );
                                        }}
                                      >
                                        <span className="title">AI PPT</span>
                                      </div>
                                    </Col>
                                  </Row>
                                </div> */}
                                <div className="name">
                                  <span>科研服务</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self",
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="yygc">
                                  <Row>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://research.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem yzzd"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"研在浙大"}>
                                                研在浙大
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                提供丰富科研工具的一站式科研门户
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://hpc.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem qzslzx">
                                            {" "}
                                          </div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"启真算力中心"}>
                                                启真算力中心
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                为学校提供高速共享科学计算能力的校级算力中心
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://cryoboat.zju.edu.cn/index/cryoboat",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem dwzz"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"低温之舟"}>
                                                低温之舟
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                专为制冷低温领域打造的科研级AI助手
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://aiearth.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem fxwx"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip
                                                title={"伏羲万象时空计算大模型"}
                                              >
                                                伏羲万象...
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                基于“伏羲万象时空计算大模型”的地学AI助手
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                            <div
                              className="listItem"
                              style={{
                                transform: `rotate(${
                                  fixedHeight ? 0 : getRotateAngle()
                                }deg)`,
                                transition: "transform 0.3s ease",
                              }}
                            >
                              <div className="listItemContent">
                                {/* <div className="name">
                                  <span>校园服务</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self"
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="xyfw">
                                  <Row>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://chat.career.zju.edu.cn/chat/pages/home "
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem img1">
                                          </div>
                                          <div className="title">
                                            <span>学生生涯导师·小叶</span>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "./?znwdId=19#/zdChat",
                                            "_self"
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem img2">
                                          </div>
                                          <div className="title">
                                            <span>总务小管家</span>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://ai-assistant-h5.zju.edu.cn/zhexiaoben-h5"
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem img3">
                                          </div>
                                          <div className="title">
                                            <span>浙小本</span>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "./?znwdId=18#/zdChat",
                                            "_self"
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem img4">
                                          </div>
                                          <div className="title">
                                            <span>医小研</span>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div> */}
                                <div className="name">
                                  <span>校园服务</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self",
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="yygc">
                                  <Row>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://ai-assistant-h5.zju.edu.cn/zhexiaoben-pc",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem zxb"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"浙小本"}>
                                                浙小本
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                本科智能教务助手
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://chat.career.zju.edu.cn/chat/pages/home",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem syds"> </div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip
                                                title={"学生生涯导师·小叶"}
                                              >
                                                学生生涯导师·小叶
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                浙大学生就业专属智能体，用“一职陪你”的理念为学生提供全周期的就业服务
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "./?znwdId=19#/zdChat",
                                            "_self",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem zwxgj"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"总务小管家"}>
                                                总务小管家
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                可提供全面的办事服务指南的校园总务小管家。
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "./?znwdId=18#/zdChat",
                                            "_self",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem yxy"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"医小研"}>
                                                医小研
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                为医学院全日制研究生提供教育教学相关政策和办事流程的专属智能助手
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                            <div
                              className="listItem"
                              style={{
                                transform: `rotate(${
                                  fixedHeight ? 0 : getRotateAngle()
                                }deg)`,
                                transition: "transform 0.3s ease",
                              }}
                            >
                              <div className="listItemContent">
                                {/* <div className="name">
                                  <span>应用广场</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self"
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="yygc">
                                  <Row>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://365.kdocs.cn/3rd/lingxi/"
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem img1"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip
                                                title={
                                                  "WPS灵犀｜浙大师生AI办公新利器"
                                                }
                                              >
                                                WPS灵犀｜浙大...
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                AI赋能高效创作，智能排版/数据分析一键搞定，解放学术科研精力！无缝兼容校园文档，团队协作更流畅，点击体验未来办公方式。
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://courses.zju.edu.cn/air/"
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem img2"> </div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"学在浙大AIR"}>
                                                学在浙大AIR
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                你的智能学伴，陪你一起探索和学习。
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "./?znwdId=8#/zdChat",
                                            "_self"
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem img3"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"ETALK"}>
                                                低温之舟
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                专注于低温领域知识的AI智能体，覆盖低温工程、低温物理、低温材料、低温应用等多个学科方向。
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "./?znwdId=16#/zdChat",
                                            "_self"
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem img4"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip
                                                title={"伏羲万象时空计算大模型"}
                                              >
                                                OCR识别
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                我是 DeepSeek-OCR
                                                模式调用助手，专门协助您从图像中提取文字和结构化信息。我可以根据您的需求，智能选择合适的
                                                OCR
                                                模式（如提取表格、识别多语言、红敏信息等），自动构建调用参数，确保高效准确地完成识别任务。您只需在对话框上传您的图片，并告诉我想要提取的内容或使用的模式，我将为您生成标准的调用指令。支持的场景包括发票识别、表格转换、文档分析等，适用于科研、办公、金融等多个领域。请随时上传图片并说明您的需求！
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div> */}
                                <div className="name">
                                  <span>实用工具</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self",
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="yygc">
                                  <Row>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://yjapi.cmc.zju.edu.cn/casapi/index.php?r=auth/login&forward=https%3A%2F%2Fconsole.cmc.zju.edu.cn%2Fyumi-aiimagelib%2Fhome%3Fsystem%3Dcmc",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem xysgj"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"校园时光机"}>
                                                校园时光机
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                以趣味互动方式沉浸式重温浙大历史与文化的AIGC工具
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://365.kdocs.cn/3rd/lingxi/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem wpslx"> </div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"WPS灵犀"}>
                                                WPS灵犀
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                深度融合在WPS
                                                Office中的智能办公助手
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://form.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem tbzs"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"填表助手"}>
                                                填表助手
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                校园智能填表工具
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "./?znwdId=16#/zdChat",
                                            "_self",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={""}></Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              ></Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ChatBoxItem>
                  </div>
                </div>
              );
            }}
          />
        </div>
      </div>

      {zdKnowledgeOpen ? (
        <>
          <Drawer
            title="知识库"
            open={zdKnowledgeOpen}
            destroyOnHidden
            width={"65%"}
            onClose={() => {
              setZdKnowledgeOpen(false);
              setZdKnowledgeName("");
              setSkillName("");
              setChooseZsk(false);
              setNewInputId("");
            }}
            footer={
              <>
                <Space>
                  <Button
                    onClick={() => {
                      setZdKnowledgeOpen(false);
                      setZdKnowledgeName("");
                      setChooseZsk(false);
                      setSkillName("");
                      setNewInputId("");
                    }}
                  >
                    关闭
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      console.log(zdKnowledgeRef);
                      const data = zdKnowledgeRef?.current?.getValue();
                      setSelectedValue({
                        key: data?.zskId,
                        name: data?.zskName,
                      });
                      setZdKnowledgeName(data?.zskName);
                      setZdKnowledgeOpen(false);
                      setSkillName(data?.zskName);
                      setNewInputId("");
                    }}
                  >
                    确定
                  </Button>
                </Space>
              </>
            }
          >
            <ZdKnowledge ref={zdKnowledgeRef} />
          </Drawer>
        </>
      ) : null}
    </div>
  ) : null;
}

export default ZdHome;
